import { IoMdClose } from "react-icons/io";
import { GrSearch } from "react-icons/gr";
import TabContainer from "../../../../components/Tab/TabContainer";

//대리점 선택
const SelectBranch = ({ branchList, selectBranch, storeId, color }) => {
  const handleChange = (e) => {
    selectBranch(e.target.value);
  };
  return (
    <select
      className={`w-full font-medium bg-white select border-${color}`}
      onChange={handleChange}
      value={storeId}
    >
      {branchList?.length > 0 ? (
        branchList.map((item, index) => (
          <option key={index} defaultValue={index === 0} value={item.id}>
            {item.name}
          </option>
        ))
      ) : (
        <option></option>
      )}
    </select>
  );
};

const SearchInput = ({
  formData,
  handleChange,
  search,
  activeTab,
  handleTabClick,
  categoryKeys,
  clearInput,
  branchList,
  selectBranch,
  color,
}) => {
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      search();
    }
  };

  const handleOnClick = (e) => {
    search();
  };

  return (
    <>
      <div className="sticky flex flex-col gap-2.5 mt-5 bg-white top-[4.5rem]">
        <TabContainer
          tabs={categoryKeys}
          activeTab={activeTab}
          onTabClick={handleTabClick}
          bgColor={color}
        />
        <SelectBranch
          branchList={branchList}
          storeId={formData.selectedBranchId}
          selectBranch={selectBranch}
          color={color}
        />

        <label
          className={`flex items-center gap-2 bg-white input input-bordered border-${color}`}
        >
          <input
            type="text"
            className="w-full font-semibold grow placeholder:text-neutral-400"
            placeholder="행사명을 검색해 주세요"
            onKeyDown={handleKeyPress}
            onChange={(e) => handleChange(e)}
            name="keyword"
            value={formData.keyword}
          />
          {formData.keyword && (
            <button
              className="flex items-center justify-center rounded-full w-7 h-7 bg-neutral-50"
              onClick={clearInput}
            >
              <IoMdClose style={{ color: "#A3A3A3" }} />
            </button>
          )}

          <button onClick={handleOnClick}>
            <GrSearch className="text-2xl" />
          </button>
        </label>
      </div>
    </>
  );
};

export default SearchInput;
